import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import CustomCheckbox from '../../../components/CustomCheckbox/CustomCheckbox';
import { GenericProjectStep } from '../../../components/GenericProjectStep';
import { HelpButton } from '../../../components/HelpButton';
import UnauthorizedScreen from '../../../components/UnauthorizedScreen/UnauthorizedScreen';
import { PROJECT_STATUS_APROVADO } from '../../../library/ProjectStatus';
import {
  changeProjetoValue,
  clearProjeto,
  loadProjeto,
} from '../../../store/modules/ProjetoActions';
import { isAuthorizedRequest } from '../../../utils/httpResponseHandlers';
import { projectIsTotalApproved } from '../../../utils/ProjetoUtils';
import { Container } from './../../../components/Container';
import ProjectStepsSidebar from './../../../components/ProjectStepsSidebar/ProjectStepsSidebar';
import { getStepSlug } from './../../../library/ProjectSteps';
import styles from './ProjetoEdit.scss';
import {
  Etapa1,
  Etapa2_1Card1,
  Etapa2_1Card2,
  Etapa2_2,
  Etapa3Card1,
  Etapa3Card2,
  Etapa4Card1,
  Etapa4Card2,
  Etapa5Card1,
  Etapa5Card2,
  Etapa6,
  Etapa7Card1,
  Etapa7Card2,
  Etapa8,
  Etapa9,
  PreEtapa1,
  PreEtapa2,
  PreEtapa3,
} from './steps/pages';

const rootClassName = styles.rootClassName;

class ProjetoEditar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      refreshing: true,
      authorizedRequest: true,
      lockedAllFields: true,
    };
  }

  changeRefreshingState(refreshing, moreProps = {}) {
    this.setState({
      ...this.state,
      refreshing: refreshing,
      ...moreProps,
    });
  }

  needLockAllFields = () => {
    if (
      this.props.projeto &&
      this.props.projeto.avaliacoes &&
      this.props.projeto.avaliacoes.length >= 10
    ) {
      const totalApproved = projectIsTotalApproved(
        [...this.props.projeto.avaliacoes],
        PROJECT_STATUS_APROVADO
      );
      const editFinished =
        this.props.auth.userPermissions.projetos.editFinished;
      if (totalApproved === true) {
        if (editFinished) {
          return false;
        }
        return true;
      }
    }
    return false;
  };

  toLoadProjeto(id) {
    this.changeRefreshingState(true);
    this.props.loadProjeto(
      id,
      () => {
        this.changeRefreshingState(false, {
          lockedAllFields: this.needLockAllFields(),
        });
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.erroCarregarProjeto,
            options: {
              variant: 'error',
            },
          });
          this.changeRefreshingState(true);
        } else {
          this.changeRefreshingState(true, {
            authorizedRequest: false,
          });
        }
      }
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const currId = this.props.match.params.id;
    const currStepSlugName = this.props.match.params.stepSlugName;
    const nextId = nextProps.match.params.id;
    const nextStepSlugName = nextProps.match.params.stepSlugName;

    if (nextId !== currId) {
      this.toLoadProjeto(nextId);
      return;
    }

    if (
      nextId &&
      nextStepSlugName === getStepSlug(10) &&
      currStepSlugName !== getStepSlug(10)
    ) {
      this.toLoadProjeto(nextId);
      return;
    }
  }

  componentWillUnmount() {
    this.props.clearProjeto();
  }

  UNSAFE_componentWillMount() {
    const currId = this.props.match.params.id;
    if (
      this.isEditing() &&
      (this.props.auth.userPermissions.projetos.edit ||
        this.props.auth.userPermissions.projetos.approve ||
        this.props.auth.userPermissions.projetos.reprove)
    ) {
      if (currId) {
        this.toLoadProjeto(currId);
        return;
      }
    }
    this.changeRefreshingState(false, {
      lockedAllFields: this.needLockAllFields(),
    });
  }

  getConsultaPublica(disabled) {
    return (
      <div className={rootClassName + '-consulta-publica-container'}>
        <CustomCheckbox
          theme='pufvYellow'
          name='consultaPublica'
          label={this.props.languageValues.consultaPublica || false}
          onChange={(event) => {
            this.props.changeProjetoValue(
              'consultaPublica',
              event.target.value
            );
          }}
          checked={this.props.projeto.consultaPublica}
          disabled={disabled}
        >
          <HelpButton text={this.props.languageValues.hintConsultaPublica} />
        </CustomCheckbox>
      </div>
    );
  }

  getStepClasses(stepIndex) {
    return rootClassName + '-etapa ' + rootClassName + '-etapa-' + stepIndex;
  }

  isEditing() {
    return this.props.match.params && this.props.match.params.id ? true : false;
  }

  getPreEtapaStep() {
    return (!this.isEditing() &&
      this.props.auth.userPermissions.projetos.register) ||
      (this.isEditing() && this.props.auth.userPermissions.projetos.edit) ? (
      <GenericProjectStep className={this.getStepClasses(0)}>
        <PreEtapa1 lockedAllFields={this.state.lockedAllFields} />
        <PreEtapa2 lockedAllFields={this.state.lockedAllFields} />
        <PreEtapa3 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa1() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(1)}
        footerItems={[this.getConsultaPublica(this.state.lockedAllFields)]}
      >
        <Etapa1 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa2_1() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(2)}
        footerItems={[
          this.getConsultaPublica(this.state.lockedAllFields),
          this.getConsultaPublica(this.state.lockedAllFields),
        ]}
      >
        {/* eslint-disable-next-line */}
        <Etapa2_1Card1 lockedAllFields={this.state.lockedAllFields} />
        {/* eslint-disable-next-line */}
        <Etapa2_1Card2 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa2_2() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(3)}
        footerItems={[this.getConsultaPublica(this.state.lockedAllFields)]}
      >
        {/* eslint-disable-next-line */}
        <Etapa2_2 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa3() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(4)}
        footerItems={[
          this.getConsultaPublica(this.state.lockedAllFields),
          this.getConsultaPublica(this.state.lockedAllFields),
        ]}
      >
        {/* eslint-disable-next-line */}
        <Etapa3Card1 lockedAllFields={this.state.lockedAllFields} />
        <Etapa3Card2 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa4() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(5)}
        footerItems={[
          this.getConsultaPublica(this.state.lockedAllFields),
          this.getConsultaPublica(this.state.lockedAllFields),
        ]}
      >
        {/* eslint-disable-next-line */}
        <Etapa4Card1 lockedAllFields={this.state.lockedAllFields} />
        <Etapa4Card2 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa5() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(6)}
        footerItems={[
          this.getConsultaPublica(this.state.lockedAllFields),
          this.getConsultaPublica(this.state.lockedAllFields),
        ]}
      >
        {/* eslint-disable-next-line */}
        <Etapa5Card1 lockedAllFields={this.state.lockedAllFields} />
        <Etapa5Card2 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa6() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(7)}
        footerItems={[this.getConsultaPublica(this.state.lockedAllFields)]}
      >
        {/* eslint-disable-next-line */}
        <Etapa6 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa7() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(8)}
        footerItems={[
          this.getConsultaPublica(this.state.lockedAllFields),
          this.getConsultaPublica(this.state.lockedAllFields),
        ]}
      >
        {/* eslint-disable-next-line */}
        <Etapa7Card1 lockedAllFields={this.state.lockedAllFields} />
        <Etapa7Card2 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa8() {
    return this.isEditing() && this.props.auth.userPermissions.projetos.edit ? (
      <GenericProjectStep
        className={this.getStepClasses(9)}
        footerItems={[this.getConsultaPublica(this.state.lockedAllFields)]}
      >
        {/* eslint-disable-next-line */}
        <Etapa8 lockedAllFields={this.state.lockedAllFields} />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getEtapa9() {
    return (this.isEditing() &&
      this.props.auth.userPermissions.projetos.edit) ||
      (this.isEditing() && this.props.auth.userPermissions.projetos.approve) ||
      (this.isEditing() && this.props.auth.userPermissions.projetos.reprove) ? (
      <GenericProjectStep className={this.getStepClasses(10)} footerItems={[]}>
        {/* eslint-disable-next-line */}
        <Etapa9
          loading={this.state.refreshing}
          lockedAllFields={this.state.lockedAllFields}
        />
      </GenericProjectStep>
    ) : (
      <UnauthorizedScreen />
    );
  }

  getStep() {
    const step = this.props.match.params.stepSlugName;
    switch (step) {
      case getStepSlug(0):
        return this.getPreEtapaStep();
      case getStepSlug(1):
        return this.getEtapa1();
      case getStepSlug(2):
        return this.getEtapa2_1();
      case getStepSlug(3):
        return this.getEtapa2_2();
      case getStepSlug(4):
        return this.getEtapa3();
      case getStepSlug(5):
        return this.getEtapa4();
      case getStepSlug(6):
        return this.getEtapa5();
      case getStepSlug(7):
        return this.getEtapa6();
      case getStepSlug(8):
        return this.getEtapa7();
      case getStepSlug(9):
        return this.getEtapa8();
      case getStepSlug(10):
        return this.getEtapa9();
      default:
        return '';
    }
  }

  render() {
    return this.state.authorizedRequest &&
      (this.props.auth.userPermissions.projetos.register ||
        this.props.auth.userPermissions.projetos.edit ||
        this.props.auth.userPermissions.projetos.approve ||
        this.props.auth.userPermissions.projetos.reprove) ? (
      <Container className={rootClassName}>
        {this.props.auth.userPermissions.projetos.register ||
        this.props.auth.userPermissions.projetos.edit ? (
          <ProjectStepsSidebar
            stepSlugName={this.props.match.params.stepSlugName}
          />
        ) : null}
        <div className={rootClassName + '-etapas'}>
          {this.state.refreshing ? '' : this.getStep()}
        </div>
      </Container>
    ) : (
      <UnauthorizedScreen />
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadProjeto,
      changeProjetoValue,
      clearProjeto,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProjetoEditar));
